$(document).on('turbolinks:load', function () {
    $('.match-teachers tr').click(function() {
        $(this).children('td').children('input').prop('checked', true);

        $('.match-teachers tr').removeClass('selected');
        $(this).toggleClass('selected')

    })})